/** For reference data that rarely changes, such as hubs, carriers and tower models. Edits still invalidate it. */
export const REFERENCE_LIST_STALE_TIME = 10 * 60 * 1000;

export async function fetchAllPages<T>(cb: (pageNo: number) => Promise<{ totalPages: number; items?: T[] }>) {
  const items: T[] = [];

  for (let page = 1; ; page++) {
    const result = await cb(page);
    items.push(...(result.items || []));

    if (page >= result.totalPages) {
      break;
    }
  }

  return items;
}
